<template>
  <div class="wrap">
    <div id="login">
      <div class="login_container">
        <h1>
          <img src="/assets/images/common/logo.png" alt="きゅうでん電気予報">
        </h1>

        <div id="err_msg" v-if="errorMsg != ''">
          <span class="err_message">
            {{errorMsg}}
          </span>
        </div>
        <form class="form" name="form-login" @submit.prevent="onLogin">
          <div>
            <span class="icon">
              <img src="/assets/images/common/icon.user.png">
            </span>
            <input type="text" id="user" placeholder="アカウント" v-model="username">
          </div>
          <div>
            <span class="icon">
              <img src="/assets/images/common/icon.password.png">
            </span>
            <input type="password" id="pass" placeholder="パスワード" v-model="password">
          </div>

          <input type="submit" value="ログイン">
        </form>
      </div>
      <footer>
        <div class="ef--inner">
          <p>Copyright (c) KYUSHU ELECTRIC POWER CO., INC. All Rights Reserved.</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "login",
  data: function() {
    return {
      username: "",
      password: "",
      errorMsg:""
    };
  },
  methods: {
    onLogin: function(event) {
      console.log("onLogin");

      this.$store.dispatch("setConfirm", { isConfirmed: false });
      const params = new URLSearchParams();
      params.append("username", this.username);
      params.append("password", this.password);
      const self = this;
      this.$axios
        .post(`/srv/api/login`, params, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          const data = response.data;
          if (data.status !== undefined) {
            if (data.status === "success") {
              self.errorMsg = ""
              this.$store.dispatch("login", { loginType: data.type, functionType: data.function_type });
              this.$store.dispatch("setLoginID", self.username);
              if (this.isParentGroupe(data.type)) {
                console.log(response.data);
                this.$store.dispatch("setChildID", "");
                if (data.type == 20) {
                  this.$store.dispatch("setParentID", self.username);
                  this.$store.dispatch("setSupplyManagement", data.supply_management);

                  // 電衛門
                  // if (data.supply_management == true) {
                  //   self.$router.push("/shop/shop_aggregation");
                  // } else {
                  //   self.$router.push("/shop");
                  // }

                  // 多回路独自
                  self.$router.push("/shop/multi_circuit_graph_list");

                } else {
                  self.$router.push("/admin");
                }
              } else {
                this.$store.dispatch("setChildID", self.username);
                if (data.function_type == 2) {
                  // 多回路独自
                  self.$router.push("/es/multi_circuit_graph_list");
                } else {
                  self.$router.push("/");
                }
              }
            } else {
              self.errorMsg = "ログインできませんでした"
              console.log("error");
              this.$store.dispatch("logout");
            }
          } else {
            self.errorMsg = "ネットワークエラー"
            console.log("error");
            this.$store.dispatch("logout");
          }
        })
        .catch(error => {
          self.errorMsg = "APIエラー"
          console.log(error);
        });
    }
  }
};
</script>

<style>
.wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
  overflow: hidden;
}
</style>
